import http from '@/core/http';
import {
  IBasicInfo,
  IKeysPageReq,
  IKeysPageRes,
  IRedisDetail,
  IAddKey,
  IUpdateKey,
  IUpdateVlaue,
  IUpdateTtl,
  ILogListItem,
} from './type.d';

/**
 * 基本信息
 */
export function getBasicInfo() {
  return http.get<IBasicInfo>({
    url: '/ops-admin/redis/console/pre/info',
    loading: true,
  });
}

/**
 * 查询key集合
 */
export function getRedisKeyList(data: IKeysPageReq) {
  return http.post<IKeysPageRes>({
    url: '/ops-admin/redis/console/keys/page',
    data,
  });
}

/**
 * 查询某个值的详细信息
 */
export function getRedisDetail(key: string) {
  return http.get<IRedisDetail>({
    url: '/ops-admin/redis/console/get',
    loading: true,
    params: { key },
  });
}

/**
 * 添加一个键值
 */
export function addKey(data: IAddKey) {
  return http.post({
    url: '/ops-admin/redis/console/save',
    loading: true,
    data,
  });
}

/**
 * 删除一个键值
 */
export function deleteKey(key: string) {
  return http.delete({
    url: '/ops-admin/redis/console/del',
    loading: true,
    params: { key },
  });
}

/**
 * 删除多个键值
 */
export function deleteKeys(key: string[]) {
  return http.post({
    url: '/ops-admin/redis/console/delete/keys',
    loading: true,
    data: key,
  });
}

/**
 * 修改一个key
 */
export function updateKey(data: IUpdateKey) {
  return http.put({
    url: '/ops-admin/redis/console/update/key',
    loading: true,
    data,
  });
}

/**
 * 修改一个值的value
 */
export function updateVlaue(data: IUpdateVlaue) {
  return http.put({
    url: '/ops-admin/redis/console/update/value',
    loading: true,
    data,
  });
}

/**
 * 修改一个值的ttl
 */
export function updateTtl(data: IUpdateTtl) {
  return http.put({
    url: '/ops-admin/redis/console/update/ttl',
    loading: true,
    data,
  });
}

/**
 * 日志查询
 */
export function getLogList(redisKey: string) {
  return http.post<ILogListItem[]>({
    url: '/ops-admin/web/v1/log/list',
    loading: true,
    data: {
      redisKey,
    },
  });
}
